import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType, ServiceGuyTypeInfo } from 't4core';
import { ServiceGuyTypeStockSettingInfo } from '../../../../../projects/t4core/src/public-api';




@Component({
  selector: 'serviceGuyTypeDialog',
  templateUrl: 'serviceGuyTypeDialog.html',
  styleUrls: ['./serviceGuyTypeDialog.css']
})



export class ServiceGuyTypeDialog extends DialogBase {

  public type: ServiceGuyTypeInfo = new ServiceGuyTypeInfo();
  public stockSettings: ServiceGuyTypeStockSettingInfo[];
  public modifiedSettings: ServiceGuyTypeStockSettingInfo[] = []; 

  public disabled: boolean = false;

  public form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
  });


  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ServiceGuyTypeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    super("ServiceGuyTypeDialog");
  }

  public async ngOnInit() {
    if (this.data.type) {
      /*this.type = this.data.type;*/
      this.type.Name = this.data.type.Name;
      this.type.Description = this.data.type.Description;
      this.type.Id = this.data.type.Id;

        this.form.setValue(
          {
            name: this.type.Name ?? '',
            description: this.type.Description ?? '',
          });
      this.form.markAsPristine();

      this.stockSettings = await this.Api.get<any[]>("/Service/GetServiceGuyTypeStockSettings", { typeId: this.type.Id });
    }
    if (this.data.newType) {
      this.type = this.data.newType;
    }
  }

  public async save() {
    if (!this.form.valid) return;
    this.disabled = true;

    var token = this.UI.beginLoading("T4.Service.ServiceGuyTypeDialog.ldrCreatingServiceGuyType", "Creating service guy type", null);

    if (this.data.newType) {
      var saveResult = await this.Api.post<boolean>("/Service/CreateServiceGuyType", this.type)
      this.UI.loaderCompleted(token);
      if (saveResult) this.dialogRef.close(true);
    }
    if (this.data.type) {
      if (this.form.dirty) await this.Api.post<boolean>("/Service/UpdateServiceGuyType", this.type)
      if (this.modifiedSettings.length > 0) await this.Api.post<boolean>("/Service/UpdateServiceGuyStockSettings", this.modifiedSettings)
      this.UI.loaderCompleted(token);
      this.dialogRef.close(true);
    }

    this.disabled = false;
    this.UI.loaderCompleted(token);
  }

  onValueChange(item: ServiceGuyTypeStockSettingInfo): void {
    const existingItem = this.modifiedSettings.find(x => x.ItemId === item.ItemId);

    if (existingItem) {
      existingItem.MinLevel = item.MinLevel;
      existingItem.RecommendedLevel = item.RecommendedLevel;
    } else {
      this.modifiedSettings.push(item);
    }
  }

}

